/**
 * Мигающая полоса тревоги со звуком (31.07): «ПОЖАР — идите к выходу».
 *
 * Показывается при БОЕВОМ кадре (живая тревога владельца или подписанный
 * `?e=`); учения не мигают и не звучат — сигнал тревоги обязан означать
 * тревогу, иначе на него перестают реагировать.
 *
 * Обе назойливости отключаемы и помнятся: паника эвакуации не помогает, а
 * мигание опасно при светочувствительной эпилепсии — поэтому «Не мигать»
 * такая же полноправная кнопка, как «Без звука».
 */
import { tr } from '@app/i18n'
import { useEffect, useState } from 'preact/hooks'
import {
  alarmMuted,
  blinkDisabled,
  retrySirenOnFirstGesture,
  setAlarmMuted,
  setBlinkDisabled,
  startSiren,
  stopSiren,
} from '../emergency/alarm-attention'
import { emergencyDrill, emergencyFrame, langTick, liveHazardUnits } from '../state'

export function AlarmBar() {
  langTick.value
  const frame = emergencyFrame.value
  const drill = emergencyDrill.value
  const [muted, setMuted] = useState(alarmMuted())
  const [still, setStill] = useState(blinkDisabled())
  const [needTap, setNeedTap] = useState(false)

  const active = frame !== null && !drill

  useEffect(() => {
    if (!active) {
      stopSiren()
      return
    }
    if (!startSiren()) {
      // Браузер держит звук до первого касания — честно просим тап.
      setNeedTap(true)
      retrySirenOnFirstGesture(() => setNeedTap(false))
    }
    return stopSiren
  }, [active])

  if (!active) return null
  const burning = liveHazardUnits.value.length

  return (
    <div class={`alarm-bar${still ? '' : ' alarm-blink'}`} role="alert">
      <span class="alarm-text">
        {tr('alarm.title')}
        {burning > 0 ? ` · ${tr('alarm.zones', { n: String(burning) })}` : ''}
      </span>
      <span class="alarm-actions">
        {needTap && !muted && (
          <button type="button" class="alarm-btn" onClick={() => startSiren() && setNeedTap(false)}>
            {tr('alarm.enable_sound')}
          </button>
        )}
        <button
          type="button"
          class="alarm-btn"
          aria-pressed={muted}
          onClick={() => {
            const next = !muted
            setAlarmMuted(next)
            setMuted(next)
            if (!next) startSiren()
          }}
        >
          {muted ? tr('alarm.sound_on') : tr('alarm.sound_off')}
        </button>
        <button
          type="button"
          class="alarm-btn"
          aria-pressed={still}
          onClick={() => {
            const next = !still
            setBlinkDisabled(next)
            setStill(next)
          }}
        >
          {still ? tr('alarm.blink_on') : tr('alarm.blink_off')}
        </button>
      </span>
    </div>
  )
}
